import { Box, Fade, styled } from '@mui/material';
import { useState } from 'react';

import FlowLoadingScreen from 'modules/common/components/FlowLoadingScreen';
import useTrustpilotSurvey from 'services/trustpilot/queries/useTrustpilotSurvey';

const StyledIframe = styled('iframe')(({ theme }) => ({
    border: 'none',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.cement[50],
    padding: theme.spacing(0.5),
}));

export default function TrustPilot() {
    const { data: surveyData, isLoading, error } = useTrustpilotSurvey();

    const [isIframeLoaded, setIsIframeLoaded] = useState(false);
    if (isLoading) {
        return null;
    }

    if (error) {
        console.error('Failed to load TrustPilot survey:', error);
        return null;
    }

    if (!surveyData?.url) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
            }}>
            <Fade in={isIframeLoaded} timeout={200} appear>
                <StyledIframe
                    title="Trustpilot"
                    src={surveyData.url}
                    onLoad={() => setIsIframeLoaded(true)}
                    onError={() => setIsIframeLoaded(false)}
                />
            </Fade>
            <Fade timeout={200} appear in={!isIframeLoaded}>
                <Box sx={{ position: 'absolute', inset: 0, zIndex: 1000 }}>
                    <FlowLoadingScreen
                        title=""
                        slotProps={{
                            box: {
                                sx: { minHeight: '100%' },
                            },
                        }}
                    />
                </Box>
            </Fade>
        </Box>
    );
}
